// External Imports
import { useContext } from "react";

// Internal Imports
import { UtilityContext } from "../../context/util-context";
import { MdArrowBack } from "react-icons/md";

/** ========================================================================
 * * Page Heading Component
 * This component is used to display a page heading with optional text.
 * ========================================================================== */

export default function Heading({
  title,
  text,
  children,
  onClick,
  isBackArrow = true,
  hideHR = false,
  id,
  backPath,
}) {
  const { goBack, navigate } = useContext(UtilityContext);

  const classNames = () => {
    let classes = "grid gap-2 rounded";
    if (onClick) classes += " p-2";
    return classes;
  };

  const clickHandler = () => {
    if (onClick) onClick();
  };

  const handleBackClick = () => {
    if (backPath) {
      navigate(backPath);
    } else if (typeof onClick === "function") {
      onClick();
    } else {
      goBack();
    }
  };

  // Current path first word after replacing special characters with /
  const path = window.location.pathname
    .replace(/[^a-zA-Z0-9]/g, "/")
    .split("/")[1];

  return (
    <div className={classNames()}>
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          {isBackArrow && (
            <MdArrowBack
              onClick={handleBackClick}
              className="text-3xl icon"
            />
          )}
          <p
            className="w-full text-lg font-semibold text-white clickable"
            onClick={clickHandler}
          >
            {title}
          </p>
        </div>
        <div className="flex items-center space-x-6">
          {id && (
            <p className="hidden text-sm text-stone-400 lg:block">ID: {id}</p>
          )}
          {children}
        </div>
      </div>
      {!hideHR && (path?.toLowerCase() !== title?.toLowerCase() || text) && (
        <hr className="hr" />
      )}
      {text && <p className="w-full text-xs text-stone-400">{text}</p>}
    </div>
  );
}
